import React, { useRef, useState } from 'react';

import cx from 'classnames';

import datePickerStyles from 'components/Pages/Admin/Itinerary/Details/shared/DatePickerButton/index.module.css';
import Popover from 'components/shared/Popover';
import { formatDateWithFullMonth } from 'utils/date';

import { FlightsDatePicker } from '../../../shared';
import s from './index.module.css';

export function Title(props) {
  const { hint, text, dateValue, onChange, dateFormat } = props;
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const containerRef = useRef();
  const titleActionRef = useRef();
  const formattedDate = dateValue
    ? formatDateWithFullMonth(new Date(dateValue), dateFormat)
    : formatDateWithFullMonth(new Date(), dateFormat);

  const handleClick = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => setIsPopupOpen(false);
  const handleChange = (enteredValue) => {
    onChange(enteredValue);
    setIsPopupOpen(false);
  };

  return (
    <div ref={containerRef}>
      <div className={cx(s.wrapper, 'custom-add-flights-title-wrapper')}>
        <div className={cx(s.title, 'custom-add-flights-title')}>
          <div className={cx(s.titleText, 'custom-add-flights-title-text')}>{text}</div>
          <div
            className={cx(s.titleAction, 'custom-add-flights-title-action')}
            onClick={handleClick}
            ref={titleActionRef}
          >
            {formattedDate}
          </div>
        </div>
        <div className={cx(s.hint, 'custom-add-flights-title-hint')}>{hint}</div>
      </div>

      {isPopupOpen && (
        <Popover
          mountEl={titleActionRef.current}
          anchorEl={containerRef.current}
          onClose={handleClosePopup}
          style={{ top: '100%', left: '0', zIndex: '99999' }}
        >
          <div className={datePickerStyles.popupContainer}>
            <FlightsDatePicker onChange={handleChange} value={dateValue} />
          </div>
        </Popover>
      )}
    </div>
  );
}
